<template>
  <portlet
      :icon="'fal fa-cloud-upload'"
      :title="'Uploaden'"
      :actionsBlock="false"
  >
    <template slot="portletBody">
      <div>
        <h3>Gewerkte uren importeren: </h3>
        <label class="file-select btn-block">
          <div class="select-button btn btn-dark btn-block">
            <span>Selecteer bestand <i class="fal fa-upload ml-2"></i></span>
          </div>
          <input id="xlsx-selector" ref="xlsxSelector" type="file" accept=".xlsx" @change="uploadWorkedHoursFile"/>
        </label>
      </div>
    </template>
  </portlet>
</template>


<script>
import axios from 'axios'

export default {
  components: {},
  data() {
    return {}
  },
  methods: {
    resetFileInput() {
      this.$refs.xlsxSelector.value = null;
    },
    async uploadWorkedHoursFile(event) {
      this.$store.commit('setLoading', true);
      const file = event.target.files[0];
      let formData = new FormData();
      formData.append('file', file);
      const result = await axios.post(this.$CLOUD_API + '/import/workedhours',
          formData,
          {
            headers: {
              'Content-Type': `multipart/form-data`,
              fbAuth: this.$FB_ID_TOKEN,
              Authorization: 'Bearer ' + this.$store.state.oAuthToken
            }
          }
      ).catch(e => {
        this.$toasted.global.failedRequest({
          message: 'Er is iets mis gegaan met importeren.'
        });
      });
      this.resetFileInput();
      this.$store.commit('setLoading', false);
      if (result) {
        this.$toasted.global.successRequest({
          message: "Bestand is succesvol geimporteerd."
        });
      }
    }
  },
  watch: {},
  computed: {}
};
</script>
<style lang="scss" scoped>
#xlsx-selector {
  display: none;
}
</style>